import votingTypes from "./action-types";
import axios from "axios";
import { showError, showSuccess } from "../../app/toastify";

import commonTypes from "../common/action-types";

const types = { ...commonTypes, ...votingTypes };

export const getVotingBehaviors = (cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      cb(true);
      const { data } = await axios.get("/api/voting/behaviors");

      dispatch({
        type: types.SET_VOTE_BEHAVIORS,
        data,
      });
      cb(false);
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};


export const getVotingRatings = (cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      cb(true);
      const { data } = await axios.get("/api/voting/ratings");

      dispatch({
        type: types.SET_VOTE_RATINGS,
        data,
      });
      cb(false);
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getMyVotes = (cb, typeId=1) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      cb(true);
      const { data } = await axios.get("/api/voting/my-votes/"+typeId);

      dispatch({
        type: types.SET_MY_VOTES,
        data,
      });
      cb(false);
      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const getEmployeeToVote = (cb, typeId=1) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      cb(true,[]);
      const { data } = await axios.get("/api/voting/employee-to-vote/"+typeId);

      cb(false,data)

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false,[]);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};

export const submitVote = (formData, cb) => {
  return async (dispatch) => {
      try {
        dispatch({ type: types.START_LOADING });
        cb(true, false);
        const { data } = await axios.post(
          `/api/voting/vote`,
          formData
        );
        dispatch({
          type: types.SET_MY_VOTES,
          data,
        });
        showSuccess(`Voting successfully submitted`);
        cb(false, true);
        dispatch({ type: types.END_LOADING });
      } catch (error) {
        cb(false, false);
        showError(error);
        dispatch({ type: types.END_LOADING });
      }
    };
};

export const getVoteDetails = (voteScoreId, cb) => {
  return async (dispatch) => {
    try {
      dispatch({ type: types.START_LOADING });
      cb(true, []);
      const { data } = await axios.get(
        `/api/voting/vote-details/${voteScoreId}`
      );

      cb(false, data);

      dispatch({ type: types.END_LOADING });
    } catch (error) {
      cb(false, []);
      dispatch({ type: types.END_LOADING });
      showError(error);
    }
  };
};